/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// doc2.ixiaochuan.cn/pages/viewpage.action?pageId=11891314
export const uploadImg = createAsyncThunk(
  'rec_uploadImg',
  async (arg: {image_contents: any}, store: any) => {
    const resp = await http.post<HiyaRes<{image_urls: string[]}>>(
      '/live/misc/upload_img',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

export const lasser_bairam_task_config = createAsyncThunk(
  'live/activity/lasser_bairam_task_config',
  async (e, store: any) => {
    const resp = await http.post('live/activity/lasser_bairam_task_config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const update_lasser_bairam_task_config_data = createAsyncThunk(
  'live/activity/update_lasser_bairam_task_config_data',
  async (e, store: any) => {
    const resp = await http.post('live/activity/lasser_bairam_task_config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const lasser_bairam_lottery = createAsyncThunk(
  'live/activity/lasser_bairam_lottery',
  async (params: {food_map: any}, store: any) => {
    const resp = await http.post('live/activity/lasser_bairam_lottery', {
      ...store.getState().env.deviceinfo,
      ...params,
    })
    return resp.data.data
  }
)
export const lasser_bairam_prize = createAsyncThunk(
  'live/activity/lasser_bairam_prize',
  async (params: {food_map: any}, store: any) => {
    const resp = await http.post('live/activity/lasser_bairam_prize', {
      ...store.getState().env.deviceinfo,
      ...params,
    })
    return resp.data.data
  }
)
export const lasser_bairam_config = createAsyncThunk(
  'live/activity/lasser_bairam_config',
  async (e, store: any) => {
    const resp = await http.post('live/activity/lasser_bairam_config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

interface foodInfo {
  food_id: number
  count: number
  desc: string
  icon: string
  value: number
  level: string
}

export const lasser_bairam_records = createAsyncThunk(
  'live/activity/lasser_bairam_records',
  async (arg: any, store: any) => {
    const resp = await http.post('live/activity/lasser_bairam_records', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

export const lasser_bairam_receive_boom_reward = createAsyncThunk(
  'live/activity/lasser_bairam_receive_boom_reward',
  async (arg: any, store: any) => {
    const resp = await http.post(
      'live/activity/lasser_bairam_receive_boom_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface MemberInfoType {
  id: number
  name: string
  zyid: string
  avatar: string
  avatar_urls: {
    origin: {
      urls: Array<string>
    }
    aspect_low: {
      urls: Array<string>
    }
  }
}
interface HistoryItem {
  member_info: MemberInfoType
  icon: string
  desc: string
  rank: number
  score: number
  data?: {
    icon: string
    desc: string
    gap_with_prev?: number
  }
}

export interface LotteryItem {
  lottery_time: string
  score: number // 美食总分
  icon: string
  desc: string
}

const initialState: {
  Cuisine: {
    is_first?: boolean
    my_food_list?: Array<{
      level: string
      food_list: Array<foodInfo>
    }>
    best_food_list?: Array<foodInfo>
    fold_food_list?: Array<foodInfo>
    task_list?: Array<{
      task_id: number
      task_num: number
      task_need: number
      status: 0 | 1
      desc: string
      jump_url: string
    }>
    my_score?: number
    user_reward_list?: Array<{avartar: string; name: string; icon: string}>
    rank_time_list?: Array<string>
  }
  Record: {
    rank_list?: {
      own?: HistoryItem
      list: Array<HistoryItem>
    }
    my_lottery_record?: Array<LotteryItem>
  }
  Result: {
    desc?: string
    icon?: string
  }
  Config: {
    status?: 0 | 1
    count_down?: number
    pool_score?: number
    is_pop_reward?: boolean
    dmk_list?: Array<{
      member: any
      desc: string
    }>
    gift_item_list?: Array<{
      desc: string
      icon: string
    }>
    member_info?: {
      rank_no: number
      gap_with_prev: number
      expect_reward: {
        icon: string
        desc: string
      }
    }
  }
  RewardInfo: {
    icons?: Array<string>
    food_sum_score?: number
  }
} = {
  Cuisine: {},
  RewardInfo: {
    icons: [],
    food_sum_score: 0,
  },
  Config: {},
  Record: {},
  Result: {},
}
export const FastingDaySlice = createSlice({
  name: 'FastingDay',
  initialState,
  reducers: {
    updateFood: (state, action) => {
      const {Cuisine} = state
      const info = action.payload
      const {fold_food_list = [], my_food_list = []} = Cuisine
      const idx1 = fold_food_list.findIndex(
        (item) => item.food_id === info.food_id
      )
      if (idx1 !== -1) {
        fold_food_list[idx1].count -= 1
        if (fold_food_list[idx1].count <= 0) {
          fold_food_list.splice(idx1, 1)
        }
      }
      const myFoodList = []
      my_food_list.forEach((item) => {
        if (item.level === info.level) {
          const index = item.food_list.findIndex(
            (fd) => fd.food_id === info.food_id
          )
          if (index !== -1) {
            item.food_list[index].count -= 1
            if (item.food_list[index].count <= 0) {
              item.food_list.splice(index, 1)
            }
          }
        }
        if (item?.food_list?.length) {
          myFoodList.push(item)
        }
      })
      Object.assign(state, {
        Cuisine: {
          ...Cuisine,
          fold_food_list,
          my_food_list: myFoodList,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(lasser_bairam_task_config.fulfilled, (state, action) => {
      Object.assign(state, {
        Cuisine: action.payload,
      })
    })
    builder.addCase(
      update_lasser_bairam_task_config_data.fulfilled,
      (state, action) => {
        const {task_list = []} = action.payload
        const {Cuisine} = state
        Object.assign(state, {
          Cuisine: {
            ...Cuisine,
            task_list,
          },
        })
      }
    )
    builder.addCase(lasser_bairam_config.fulfilled, (state, action) => {
      Object.assign(state, {
        Config: action.payload,
      })
    })
    builder.addCase(lasser_bairam_prize.fulfilled, (state, action) => {
      const {icons = [], food_sum_score = 0} = action.payload
      Object.assign(state, {
        RewardInfo: {
          icons,
          food_sum_score,
        },
      })
    })
    builder.addCase(lasser_bairam_records.fulfilled, (state, action) => {
      Object.assign(state, {
        Record: action.payload,
      })
    })
    builder.addCase(
      lasser_bairam_receive_boom_reward.fulfilled,
      (state, action) => {
        Object.assign(state, {
          Result: action.payload,
        })
      }
    )
  },
})
export default FastingDaySlice.reducer
export const FastingDayActions = FastingDaySlice.actions

export function useFastingDay() {
  return useSelector((store) => store.FastingDay)
}
